var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M116 1.91034C115.997 2.45733 115.757 2.97624 115.343 3.33352C112.684 5.75527 111.168 9.18479 111.167 12.7812V64.2346C111.167 67.0287 110.056 69.7083 108.08 71.6835C106.104 73.6587 103.424 74.7676 100.63 74.7661H99.8524C95.2052 74.7661 90.64 71.0495 89.9996 66.4515C89.1421 60.6558 83.9568 56.5043 78.1139 56.9356C72.2709 57.367 67.7514 62.2348 67.7542 68.0936V96.8856C67.7542 101.097 67.7542 105.304 67.7542 106.421C67.7542 110.592 66.7464 111.227 63.3951 111.227H4.80596C2.1517 111.227 0 109.075 0 106.421V66.769C0.00145078 63.8021 1.18179 60.9575 3.2812 58.8611C5.38061 56.7648 8.22701 55.5886 11.1938 55.5915H34.9664C37.7274 55.6003 40.3778 54.5074 42.3301 52.5551C44.2824 50.6028 45.3753 47.9524 45.3665 45.1914V12.7812C45.3726 5.72486 51.0914 0.00603626 58.1478 0H114.106C115.156 0.00602957 116.003 0.860439 116 1.91034Z",
  fill: "#D1DAE1"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95.818 18.7587H59.3463",
  stroke: "white",
  strokeWidth: 4
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M95.818 27.9655H59.3463",
  stroke: "white",
  strokeWidth: 4
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M95.818 37.1724H59.3463",
  stroke: "white",
  strokeWidth: 4
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M95.818 46.3847H59.3463",
  stroke: "white",
  strokeWidth: 4
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2561 70.5624H14.7844",
  stroke: "white",
  strokeWidth: 4
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2561 79.293H14.7844",
  stroke: "white",
  strokeWidth: 4
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2561 88.0291H14.7844",
  stroke: "white",
  strokeWidth: 4
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2561 96.7653H14.7844",
  stroke: "white",
  strokeWidth: 4
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M95.818 55.5916H59.3463",
  stroke: "white",
  strokeWidth: 4
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M95.8126 65.2473H87.0217",
  stroke: "white",
  strokeWidth: 4
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8523 74.7442H67.7323V68.0498C67.7295 62.191 72.249 57.3232 78.0919 56.8918C83.9349 56.4605 89.1202 60.6119 89.9777 66.4077C90.6455 71.0275 95.2051 74.7442 99.8523 74.7442Z",
  fill: "#194867"
});
function SvgStaticList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 112,
    viewBox: "0 0 116 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticList);
export default __webpack_public_path__ + "static/media/staticList.be9b1cbe7effc9e4e9d508488293a027.svg";
export { ForwardRef as ReactComponent };